// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.9999 1.9165L22.0999 6.12484L11.9999 10.3332L1.8999 6.12484L11.9999 1.9165ZM1.9999 9.9802L11.9999 14.2881L21.9999 9.9802V12.1611L11.9999 16.4657L1.9999 12.1611L1.9999 9.9802ZM1.9999 15.9802L11.9999 20.2881L21.9999 15.9802V18.1611L11.9999 22.4657L1.9999 18.1611L1.9999 15.9802Z"}}]};

const LayersFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'layers-filled',
    ref,
    icon: element,
  },
));

LayersFilledIcon.displayName = 'LayersFilledIcon';

export default LayersFilledIcon;
